import { useEffect } from "react";

export default function FacebookBusinessLoginButton({ appId, version, configId, extras, onSuccess, onEmbeddedSignupEvent, onError, disabled, children }) {
  useEffect(() => {
    if (!appId || !version || !configId) {
      console.error("FacebookBusinessLoginButton: appId, version e configId são obrigatórios.");
      return;
    }

    if (document.getElementById("facebook-jssdk")) return;

    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        cookie: true,
        xfbml: false,
        version
      });
    };

    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = `https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v${version}&appId=${appId}`;
    script.async = true;
    document.body.appendChild(script);
  }, [appId, version, configId]);

  useEffect(() => {
    if (!onEmbeddedSignupEvent) return;

    const sessionInfoListener = (event) => {
      if (!event.origin.endsWith('facebook.com')) return;
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          onEmbeddedSignupEvent(data);
        }
      } catch (_) {
        // mensagem não-JSON, ignorar
      }
    };

    window.addEventListener("message", sessionInfoListener);
    return () => window.removeEventListener("message", sessionInfoListener);
  }, [onEmbeddedSignupEvent]);

  const handleLogin = () => {
    if (!window.FB) {
      onError?.(new Error("Facebook SDK não carregada"));
      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse) {
          onSuccess?.(response.authResponse);
        } else {
          onError?.(new Error("Login cancelado ou não autorizado"));
        }
      },
      {
        config_id: configId,
        response_type: 'code',
        override_default_response_type: true,
        ...extras,
      }
    );
  };

  return (
    <>
      <div id="fb-root"></div>
      <button
        onClick={handleLogin}
        disabled={disabled}
        style={{
          backgroundColor: disabled ? "#999" : "#1877F2",
          color: "white",
          border: "none",
          padding: "10px 16px",
          borderRadius: "4px",
          cursor: disabled ? "not-allowed" : "pointer",
          fontSize: "14px",
        }}
      >
        {children || "Entrar com Facebook"}
      </button>
    </>
  );
}
